module.exports = __webpack_public_path__ + "media/bootstrap-icons/info-lg-0752dd48.svg";